export const Role = {
    Admin: 'Admin',
    RegisterAdmin: 'RegisterAdmin',
    FinancialControl: 'FinancialControl',
    Lector: 'Lector',
    Accounting: 'Accounting',
    Coordinator: 'Coordinator',
    ProjectManager: 'ProjectManager',
    Director: 'Director',
    DevAdmin: 'DevAdmin',
    EventAdmin: 'EventAdmin',
    Nip: 'NipEmployee',
    Participant: 'Participant',
    VerifiedUser: 'VerifiedUser',
    SuperAdmin: 'SuperAdmin'
}
